import React, { lazy, Suspense } from 'react';
import { Alert } from 'antd';
import { useParams } from 'react-router';
import { useQuery } from '@apollo/client';
import { GET_SITE_VISIT } from '../../graphql/queries/siteVisit';
import { Loader } from '../../components/UI/Loader';

const SiteVisitProvider = lazy(() =>
  import('../../modules/SiteVisit').then(module => ({ default: module.SiteVisitProvider }))
);
const SiteVisitTool = lazy(() =>
  import('../../modules/SiteVisit').then(module => ({ default: module.SiteVisitTool }))
);

const SiteVisitEditPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const { data, loading, error } = useQuery(GET_SITE_VISIT, {
    variables: { id },
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
  });

  if (loading) return <Loader />;

  if (error) {
    return (
      <Alert
        message="Data loading error"
        description="Failed to load visit data. Please try refreshing the page."
        type="error"
        showIcon
      />
    );
  }

  if (!data?.siteVisit) {
    return (
      <Alert
        message="Visit not found"
        description="The requested visit does not exist or has been deleted."
        type="warning"
        showIcon
      />
    );
  }

  return (
    <Suspense fallback={<Loader />}>
      <SiteVisitProvider key={data.siteVisit.id} initialSiteVisit={data.siteVisit}>
        <Suspense fallback={<Loader />}>
          <SiteVisitTool />
        </Suspense>
      </SiteVisitProvider>
    </Suspense>
  );
};

export default SiteVisitEditPage;
